// extracted by mini-css-extract-plugin
export default {"appealsTable":"GlobalAppeals_appealsTable__sJemJ"};